module.exports = __webpack_public_path__ + "img/Frente-77-01 on.46908647.png";